import React from 'react';

const MobileHero: React.FC = () => {
  return (
    <section className="md:hidden pt-16">
      <div className="grid grid-cols-2 h-[50vh]">
        {/* Restaurant Side */}
        <a 
          href="/restaurant" 
          className="relative bg-primary-black flex flex-col items-center justify-center border-r border-gray-800 overflow-hidden group"
          aria-label="Visit our restaurant page"
        >
          <div 
            className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
            style={{
              backgroundImage: "url('/images/restaurant/full-dining-room.webp')",
            }}
          ></div>
          <div className="absolute inset-0 bg-primary-black opacity-80"></div>
          <div className="relative z-10 text-center px-4">
            <h2 className="text-2xl font-bold text-primary-gold font-display">
              Restaurant
            </h2>
          </div>
        </a>

        {/* Snooker & Pool Side */}
        <a 
          href="/snooker" 
          className="relative bg-primary-black flex flex-col items-center justify-center overflow-hidden group"
          aria-label="Visit our snooker and pool page"
        >
          <div 
            className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
            style={{
              backgroundImage: "url('/images/snooker/snooker-player-aiming.webp')",
            }}
          ></div>
          <div className="absolute inset-0 bg-primary-black opacity-80"></div>
          <div className="relative z-10 text-center px-4">
            <h2 className="text-2xl font-bold text-primary-gold font-display">
              Snooker & Pool
            </h2>
          </div>
        </a>
      </div>
    </section>
  );
};

export default MobileHero;
